module.exports = __webpack_public_path__ + "static/media/richard-ekwonye.5c39cfd6.png";